





















import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';

import { mapGetters } from 'vuex';

import { CONFIG_CONSTS } from '../../store/config/config.consts';

export default {
  name: 'product-item',
  props: {
    product: Object,
    selectedAction: String
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance
    }),
    getProductImage: function (): string {
      return !!this.product.imageUrl ? this.product.imageUrl : require('../../assets/media/image/image-not-found.svg');
    }
  },
  data: function () {
    return {
      hovered: false
    };
  },
  methods: {
    toggleSelected: function (action: RankingActionEnum): void {
      const productMapped = {
        ...this.product,
        fieldName: this.instanceConfig.catalog.resultMappings.id,
        fieldValue: this.product.id,
        action: action,
        schedule: {
          activationDate: null,
          deactivationDate: null
        },
        filters: {}
      };
      this.$emit('toggleSelect', productMapped);
    }
  }
};
